<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <h3>
                    Record Invoice Payment
                </h3>
                <h4 class="color-orange">
                    {{ recordPaymentForName }}
                </h4>
                <hr>
                <h5 style="line-height: 30px">
                    Total : {{ selectedInvoice.currency_type | CurrencySymbol }}{{ selectedInvoice.invoice_amount }}<br>
                    Paid  : {{ selectedInvoice.currency_type | CurrencySymbol }}{{ totalPaidAmount }}<br>
                    Left  : {{ selectedInvoice.currency_type | CurrencySymbol }}{{ totalLeftAmount.toFixed(2) }}<br>
                </h5>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-md-12">
                <form class="form" v-on:submit.prevent="recordInvoicePayment">
                    <fieldset>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-wrap">
                                    <div>
                                        <label for="estimated_cost">Amount paid</label>
                                        <input id="estimated_cost" 
                                                type="number" 
                                                step="0.01"
                                                placeholder="Amount paid"
                                                @keyup="checkPaymentAmount"
                                                v-model="recordpayment.paid_amount" 
                                                required>
                                        <small v-if="paymentErrorMessage" class="text-danger">{{ paymentErrorMessage }}</small>
                                    </div> 
                                    <div>
                                        <label for="payment_mode"> Payment mode </label>
                                        <v-select
                                            id="payment_mode"
                                            :options="['Bax','Card','checque','cash','bank']"
                                            placeholder="Payment mode"
                                            v-model="recordpayment.payment_mode"
                                            />
                                    </div> 
                                    <div>
                                        <label for="payment_number">Payment number</label>
                                        <input id="payment_number" type="text" placeholder="Payment number" v-model="recordpayment.transaction_number">
                                    </div>
                                    <div>
                                        <label for="paid_date"> Paid Date </label>
                                        <input id="paid_date" type="date" placeholder="Paid date" v-model="recordpayment.payment_date">
                                    </div>
                                    <div class="mt-4">
                                        <div class="form-submit-inline">
                                            <button type="submit" class="button" :disabled="isError ? true : false">
                                                <span> {{(recordpayment.flag == 'add' ) ? 'Add' : 'Edit' }} payment </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
        <hr>
        <div class="row">
        <div class="col-md-12">
            <table class="table" cellspacing="0">
                <thead>
                    <tr>
                        <th>Amount Paid</th>
                        <th>Paymend Mode</th>
                        <th>Transaction Number</th>
                        <th>Paid Date</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
            <tbody>
                <template v-if="recordedPayments.length > 0 ">
                    <tr v-for="payment in recordedPayments" :key="payment.id">
                        <td>{{ selectedInvoice.currency_type | CurrencySymbol }}{{ Number(payment.paid_amount) }}</td>
                        <td>{{ payment.payment_mode }}</td>
                        <td>{{ payment.transaction_number }}</td>
                        <td>{{ payment.payment_date }}</td>
                        <td class="table-action"><a v-on:click="editRecordedPayment(payment.id)"  class="button p-2">Edit</a></td>
                        <td class="table-action"><a v-on:click="deleteRecordedPayment(payment.id)" class="button p-2">Delete</a></td>
                    </tr>
                </template>
                <template v-else>
                    <tr>
                        <td colspan="4" class="text-center"> 
                        <h4>No data available.</h4>
                        </td>
                    </tr>
                </template>
                
            </tbody>
            </table>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecordPaymentModal',
    data() {
        return {
            recordpayment: {
                flag: 'add',
                payment_for: this.paymentfor,
                payment_for_id: this.paymentforid,
                invoice_id:this.selectedInvoice.id,
                paid_amount: null,
                payment_mode:null,
                payment_date: null,
                transaction_number:null
            },
            isError: false,
            paymentErrorMessage:null,
        }
    },
    props: {
        paymentfor: String,
        paymentForObject:Object,
        paymentforid:Number,  
        selectedInvoice:Object,  
        recordedPayments:Array,  
    },
    computed: {
        recordPaymentForName () {
            let paymentForName = null;

            if (this.paymentfor == 'supplier') {
                paymentForName = this.paymentForObject.supplier_name
            } else if (this.paymentfor == 'tour_manager') {
                paymentForName = `${this.paymentForObject.firstname} ${this.paymentForObject.lastname}`
            }

            return  paymentForName
        },
        totalPaidAmount() {
            let paidAmount = 0
            if (this.recordedPayments.length > 0 ) {
                this.recordedPayments.forEach(element => {
                    paidAmount+=Number(element.paid_amount)
                });
            }

            return paidAmount.toFixed(2);
        },
        totalLeftAmount() {
            return Number(this.selectedInvoice.invoice_amount) - this.totalPaidAmount
        }
    },
    methods: {
        checkPaymentAmount() {
            let usedAmount = this.recordedPayments.reduce((accumulator ,item) => {
                return accumulator += item.paid_amount;
            }, 0)

            let invoiceTotalAmount = Number(this.selectedInvoice.invoice_amount)

            let usableAmount = invoiceTotalAmount - usedAmount

            if (this.recordpayment.paid_amount > usableAmount) {
                this.isError = true;
                this.paymentErrorMessage = `Please provide a valid amount upto ${usableAmount}`
            } else {
                this.isError = false;
                this.paymentErrorMessage = null
                
            }

        },
        recordInvoicePayment() {
            let self = this

            self.$store.dispatch('setLoadStatus')
  
            fetch(`${self.$api}invoice/record-payment`, {
                method: 'POST',
                body: JSON.stringify(self.recordpayment),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                self.errors = response.errors
                if(response.status) {
                    self.$notify({
                        type: 'success',
                        title: response.message
                    });
                    self.recordpayment = {
                        flag: 'add',
                        payment_for: this.paymentfor,
                        payment_for_id: this.paymentforid,
                        invoice_id:this.selectedInvoice.id,
                    }

                    self.$emit('syncPayments', response.recorded_payments)
                    
                } else if (response.errors) {
                    This.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                self.$store.dispatch('setLoadStatus')
            });
        },
        editRecordedPayment(payment_id) {
            let foundPayment = this.recordedPayments.find(element => element.id === payment_id)
            if (foundPayment) {
                this.recordpayment = {
                    flag: 'edit',
                    payment_for: this.paymentfor,
                    payment_for_id: this.paymentforid,
                    invoice_id: this.selectedInvoice.id,
                    invoice_payment_id : payment_id,
                    paid_amount: foundPayment.paid_amount,
                    payment_mode:foundPayment.payment_mode,
                    payment_date: foundPayment.payment_date,
                    transaction_number:foundPayment.transaction_number
                }
            }
        },
        deleteRecordedPayment(payment_id) {
            this.$dialog
            .confirm(`Are you sure you want to delete this recorded payment ?`)
            .then(() => {
                this.$store.dispatch('setLoadStatus')
                fetch(`${this.$api}invoice/delete-record-payment`, {
                    method: 'POST',
                    body: JSON.stringify({
                        'payment_for' : this.paymentfor,
                        'payment_for_id' : this.paymentforid,
                        'invoice_id': this.selectedInvoice.id,
                        'invoice_payment_id' : payment_id
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => res.json())
                .then(response => {
                    this.errors = response.errors
                    if(response.status) {
                        this.$notify({
                            type: 'success',
                            title: response.message
                        });
                        this.$emit('syncPayments', response.recorded_payments)
                    } else if (response.errors) {
                        this.$notify({
                            type: 'error',
                            title: response.message
                        });
                    } else {
                        this.$notify({
                            type: 'error',
                            title: response.Error
                        });
                    }
                    this.$store.dispatch('setLoadStatus')
                });
            }).catch(() => {
                this.$store.dispatch('setLoadStatus')
                console.log('Clicked on cancel');
            });
        }    
    }
}
</script>

<style lang="scss" scoped>

</style>